<template>
  <div
    id="app"
    v-loading.fullscreen.lock="isLoading"
    element-loading-text="拼命加载中…"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 1)"
  >
    <div v-show="!$store.state.isLogin" class="logOutNavigator"></div>
    <Navigator v-show="$store.state.isLogin" />
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navigator from "@/views/Navigator";
import { initData } from "@/views/News/index";
export default {
  components: {
    Navigator,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async init() {
      // console.log(await initData(this, "中国", false))
      this.$store.commit("setChinaValue", await initData(this, "中国"));
    },
  },
  created() {
    // 数据缓存入store
    // this.init()
  },
  mounted() {
    this.$router.push("/Login");
  },
};
</script>
<style lang="scss">
$fontColor: #eee;
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
#app {
  overflow: hidden;
  // text-align: center;
  .logOutNavigator {
    height: 55px;
    background-color: #101c45;
    box-shadow: 0 0 1.5em $innerLight inset;
  }
  .content {
    // background-image: linear-gradient(#1d4691, #52aed8);
    background-image: url("./assets/image/background.png");
    // background-size: fixed;
    width: 100%;
    position: absolute;
    top: 55px;
    bottom: 0;
    left: 0;
    color: $fontColor;
  }
}
</style>
